import { render, staticRenderFns } from "./option-group-view.vue?vue&type=template&id=c0e1b4a0&"
import script from "./option-group-view.vue?vue&type=script&lang=ts&"
export * from "./option-group-view.vue?vue&type=script&lang=ts&"
import style0 from "./option-group-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports